import styled from 'styled-components';
import { AllieText } from '../Text';

export const StyledText = styled(AllieText)<{ selected: boolean }>`
  color: ${(props) => (props.selected ? 'var(--allie-color-primary-40)' : 'inherit')};
  font-weight: 600;
  margin-bottom: 6px;
  width: fit-content;
`;

export const StyledGridContent = styled.div<{ hasBlocked?: boolean }>`
  cursor: pointer;
  flex: ${(props) => (props.hasBlocked ? '1 0 35%' : 'none')};
  width: 100%;
  white-space: nowrap;
  background-color: var(--allie-color-neutral-10);
  border-radius: 8px;
`;
